module.exports = __webpack_public_path__ + "static/media/AornotB.ebfec3c7.svg";